import { HoldingService } from "./../../../../services/http/business/holding/holding.service";
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
} from "@angular/core";

import { IGroup } from "src/app/interfaces/group";
import { TranslateService } from "@ngstack/translate";
import { GroupService } from "src/app/services/http/business/group/group.service";
import { MatSelectChange } from "@angular/material";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";

@Component({
  selector: "app-group-list",
  templateUrl: "./group-list.component.html",
  styleUrls: ["./group-list.component.css"]
})
export class GroupListComponent implements OnInit {
  isOwner: boolean;
  groupList: IGroup;
  selectGroup: string;
  companyList: ICompany[];
  @Output() groupId = new EventEmitter();

  companySelected: string;

  constructor(
    private cidService: CIDService,
    private groupService: GroupService,
    public translate: TranslateService,
    private companyService: CompanyService,
    private holdingService: HoldingService
  ) {}

  ngOnInit() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
    this.groupService.change.subscribe(() => {
      this.refresh();
      this.selectGroup = "";
    });
    this.refresh();
  }

  onDetail(event: MatSelectChange) {
    this.groupId.emit(event.value);
  }

  refresh() {
    this.groupService.list(0, 0).subscribe(res => {
      this.groupList = res.DataList;
      this.companySelected = this.cidService.getCID();
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  loadGroups(e: string) {
    this.cidService.setCID(e);
    this.refresh();
    this.groupService.hide();
  }

  // ngOnDestroy() {
  //   if (this.isOwner) this.cidService.setCID("");
  // }
}
